import React from "react";
import { Link as RouterLink } from "react-router-dom";

const Link = ({ to, href, children, ...props }) => {
  const dest = to || href;
  const isInternal = dest?.startsWith("/") && !dest.startsWith("//");

  if (isInternal) {
    return (
      <RouterLink to={dest} {...props}>
        {children}
      </RouterLink>
    );
  }

  return (
    <a href={dest} {...props}>
      {children}
    </a>
  );
};

export default Link;
